import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchScaleDataForTicket (_, ticketId) {
    const path = `tickets/${ticketId}/scaleData`
    const response = await ApiServer.get(path)
    return response.data
  },

  async fetchVolumeSummaryForTicket (_, ticketId) {
    const path = `tickets/${ticketId}/volumeSummary`
    const response = await ApiServer.get(path)
    return response.data
  },

  async createVolumeData (_, { volumeData, forceReScale = false }) {
    const path = `tickets/${volumeData.ticketId}/volumeData`
    const forceReScaleHeader = { forceReScale: forceReScale }
    const response = await ApiServer.post(path, volumeData, { headers: forceReScaleHeader })
    return response.data
  }
}
